import LegalPage from "@/components/LegalPage";

const SECTIONS = [
  {
    id: "who-we-are",
    heading: "Who we are",
    body: [
      "Modi Marine (\"Modi Marine\", \"we\", \"us\") is a unit of Modi Auto Group and the Indian representative for a curated portfolio of international yacht and boat builders. This Privacy Policy explains how we collect, use, share and protect personal information when you visit www.modimarine.com, contact us, or engage with our services.",
      "This policy is published in accordance with the Information Technology Act, 2000, the Information Technology (Reasonable Security Practices and Procedures and Sensitive Personal Data or Information) Rules, 2011, and the Digital Personal Data Protection Act, 2023.",
    ],
  },
  {
    id: "what-we-collect",
    heading: "Information we collect",
    body: [
      "We collect only what is needed to respond to you and to improve our website:",
      [
        "Details you provide through our enquiry forms — name, email address, telephone number, area of interest and your message.",
        "Communication records when you contact us by telephone, email or WhatsApp.",
        "Technical data collected automatically — IP address, browser type, device, pages visited, referring source and approximate location — through cookies and similar technologies.",
        "Advertising identifiers and campaign parameters (such as UTM tags) when you arrive from one of our advertisements.",
      ],
      "We do not knowingly collect information from anyone under the age of 18, and we never ask for payment-card details, passwords or government identity numbers through this website.",
    ],
  },
  {
    id: "how-we-use",
    heading: "How we use your information",
    body: [
      [
        "To respond to your enquiry and arrange consultations, viewings or sea trials.",
        "To share brochures, specifications and pricing for the yachts you have expressed interest in.",
        "To keep you informed about new models, events and private previews — only where you have agreed to hear from us.",
        "To understand how our website is used and to improve its content, design and performance.",
        "To measure and optimise our advertising campaigns.",
        "To comply with legal obligations and to protect our rights, property and safety.",
      ],
    ],
  },
  {
    id: "cookies",
    heading: "Cookies and analytics",
    body: [
      "Our website uses cookies and similar technologies, including the Meta Pixel, to measure visits, remember your preferences and show you relevant advertising on third-party platforms. These tools may collect information about your interaction with our pages and with the yachts you view.",
      "You can control cookies through your browser settings and opt out of interest-based advertising through the preference tools offered by Meta and other advertising platforms. Disabling cookies may affect how parts of the website function.",
    ],
  },
  {
    id: "sharing",
    heading: "Who we share it with",
    body: [
      "We treat your information as confidential. It may be shared only with:",
      [
        "The shipyards and brands we represent, where this is necessary to answer a specific enquiry about their yachts.",
        "Companies within Modi Auto Group that support our sales and after-sales operations.",
        "Service providers who help us operate the website, send email and host our data, under contractual confidentiality obligations.",
        "Regulators, courts or law-enforcement agencies where required by law.",
      ],
      "We do not sell your personal information to anyone.",
    ],
  },
  {
    id: "security-retention",
    heading: "Security and retention",
    body: [
      "We use industry-standard safeguards — encrypted connections, access controls and secure hosting — to protect your information against unauthorised access, alteration or loss. Enquiry records are retained for as long as needed to serve you and for a reasonable period thereafter to meet legal, accounting and reporting requirements, after which they are deleted or anonymised.",
    ],
  },
  {
    id: "your-rights",
    heading: "Your rights",
    body: [
      "You may ask us at any time to access, correct, update or erase the personal information we hold about you, to withdraw consent to marketing communications, or to raise a grievance about how your data has been handled. Please write to bespoke@modimarine.com and we will respond within the timeframes prescribed by applicable law.",
    ],
  },
  {
    id: "changes-contact",
    heading: "Changes and contact",
    body: [
      "We may update this policy from time to time. The date at the top of this page shows when it was last revised, and any material changes will be posted here.",
      "Grievance Officer, Modi Marine · bespoke@modimarine.com · +91 89178 89178",
    ],
  },
];

export default function PrivacyPolicyPage() {
  return (
    <LegalPage
      testId="privacy-page"
      title="Privacy"
      accent="Policy."
      updated="October 2026"
      intro="Discretion is the foundation of everything we do. This policy sets out, in plain language, what information we collect when you visit Modi Marine online or contact us, how we use it, and the choices available to you."
      sections={SECTIONS}
    />
  );
}
